import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Button, Form, FormGroup,
         Label, Input, Col, Row } from 'reactstrap';
import {connect} from 'react-redux';
import { getBalanceAccount} from '../actions/infoAccountActions';
import { getSettings} from '../actions/settingActions';
import { saveAccountId } from '../actions/loginActions';
import  InfoRow from './InfoRow';
import { NavLink } from 'react-router-dom';
import T from 'i18n-react';

class HeaderApp extends Component {
  constructor(props) {
    super(props);
    console.log('Header constructor');
    console.log('Header props', props);

  }

  componentWillMount(){ //before render
    let accountId = localStorage.getItem('accountId');
    console.log('InfoRow componentWillMount', accountId);
    if (accountId){
      this.props.saveAccountId(accountId);
      this.props.getBalanceAccount(accountId);
      this.props.getSettings(accountId);
    }
  }

  onLogoutClick = (e) => {
    console.log('logout');
    const { router } = this.context;
    router.history.push('/');
    localStorage.removeItem('accountId');
    this.props.saveAccountId('');
  }

  render() {
      return(
        <nav>
          <div className="row">
             <div className="col-sm-4 col-md-3 col-lg-2">
               <NavLink exact to="/" className="navbar-brand" href="#">
                 <span className="logo-park">Park</span>
                 <span className="logo-pall">Pal</span>
               </NavLink>
             </div>

            <div className="col-sm-6 col-md-7 col-lg-8" id="infoRowWrap">
                { this.props.accountId &&
               <InfoRow />
              }
           </div>

           <div className="col-sm-2 col-md-2 col-lg-2" id="logOutWrap">
             { this.props.accountId &&
               <NavLink exact to="#" style={{float:'right', marginRight: '5px', whiteSpace: 'nowrap'}}
                  onClick={this.onLogoutClick}>
                 <T.text tag='span' text="log_out"/>
              </NavLink>
            }
           </div>
         </div>
        </nav>
    )
  }
}

HeaderApp.contextTypes = {
  router: React.PropTypes.object
}

HeaderApp.propTypes = {
  children: PropTypes.element
};

//export default HeaderApp;
const Header1 = connect((state)=>{
  return {
    phoneNumber: state.authReducer.phoneNumber,
    licensePlate: state.authReducer.licensePlate,
    balance: state.authReducer.balance,
    accountId: state.authReducer.accountId
  }
},
{ getBalanceAccount,
  getSettings,
  saveAccountId})(HeaderApp);

export default Header1;



// WEBPACK FOOTER //
// ./src/components/Header.js